import { devicePermissionsStore } from 'owa-app-host-state/lib/store/devicePermissionsStore';

export function isDevicePermissionsDialogOpen(): boolean {
    const store = devicePermissionsStore();
    return store.isOpen && !!store.appId;
}
